module.exports = __webpack_public_path__ + "static/media/world.5027d763.jpg";